export default "__VITE_ASSET__b5d52ee0__"